import { MunicipalTabulation, ProvincialDistrictTabulation, Tabulation } from '../../types';

import MunicipalDash from './MunicipalDash';
import ProvincialDistrictDash from './ProvincialDistrictDash';
import React from 'react';

interface TabulationDashProps {
  tabulation: Tabulation;
  navToStats?: boolean;
  showAll?: boolean;
  onComplete?: () => void;
}

const TabulationDash: React.FC<TabulationDashProps> = ({ 
  tabulation, 
  navToStats = false, 
  showAll = true,
  onComplete
}) => {
  return (
    <>
      {tabulation.type === "district" && (
        <ProvincialDistrictDash
          tabulation={tabulation as ProvincialDistrictTabulation}
          navToStats={navToStats}
          showAll={showAll}
          onComplete={onComplete}
        />
      )}
      {tabulation.type === "municipal" && (
        <MunicipalDash 
          tabulation={tabulation as MunicipalTabulation}
          navToStats={navToStats}
          showAll={showAll}
          onComplete={onComplete}
        />
      )}
    </>
  );
};

export default TabulationDash;
